export default {
	title: 'valve',
	components: [{ title: 'valve', component: 'valve' }],
};
